"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { Label } from "semantic-ui-react";
import ButtonItem from "../../../components/Button";
import { fetchUserAttributes } from "aws-amplify/auth";
import { editorData } from "../../Neighborhood/[id]/data.json";

const ShareCommentsButton = ({ cityId, cityDetails }) => {
  const router = useRouter();
  const [isEditor, setIsEditor] = useState(false);
  const [loggedin, setLoggedin] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        const attributes = await fetchUserAttributes();
        const userEmail = attributes.email;

        setLoggedin(true);

        // Check if user is an editor
        if (userEmail && editorData.includes(userEmail)) {
          setIsEditor(true);
        }
      } catch (error) {
        setLoggedin(false);
        setIsEditor(false);
      }
    };

    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkUserStatus();
    checkMobile();

    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  /**
   * Handle click for editor users
   */
  const handleEditorReviewClick = () => {
    // Store city details in localStorage for use in review page
    if (cityDetails && cityDetails.length > 0) {
      localStorage.setItem("citydetails", JSON.stringify(cityDetails));

      const cityData = cityDetails[0];
      localStorage.setItem("cityname", cityData?.postalcity_name || "");
      localStorage.setItem(
        "statename",
        cityData?.label?.split(",")?.pop()?.trim() || "",
      );
    }

    // Store city ID
    localStorage.setItem("cityId", cityId || "");

    if (loggedin) {
      localStorage.removeItem("saveR");
      router.push("/CityReview?role=editor");

      if (typeof window !== "undefined") {
        window.scrollTo(0, 0);
      }
    } else {
      localStorage.setItem("saveR", "saveReview");

      if (typeof window !== "undefined") {
        localStorage.setItem("previous_url", window.location.href);
      }

      const signUpBtn = document.getElementById("sign_up_btn");
      if (signUpBtn) {
        signUpBtn.click();
      }
    }
  };

  /**
   * Handle click for regular users
   */
  const handleReviewClick = () => {
    // Store city details in localStorage for use in review page
    if (cityDetails && cityDetails.length > 0) {
      localStorage.setItem("citydetails", JSON.stringify(cityDetails));

      const cityData = cityDetails[0];
      localStorage.setItem("cityname", cityData?.postalcity_name || "");
      localStorage.setItem(
        "statename",
        cityData?.label?.split(",")?.pop()?.trim() || "",
      );
    }

    // Store city ID
    localStorage.setItem("cityId", cityId || "");

    localStorage.removeItem("saveR");
    router.push("/CityReview");

    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }

    if (!loggedin && typeof window !== "undefined") {
      localStorage.setItem("previous_url", window.location.href);
    }
  };

  /**
   * Main click handler
   */
  const handleClick = () => {
    if (isEditor) {
      handleEditorReviewClick();
    } else {
      handleReviewClick();
    }
  };

  return (
    <span>
      <ButtonItem
        as="div"
        labelPosition="right"
        floated="right"
        onClick={handleClick}
        className="theme_blue btn_blue"
      >
        <ButtonItem icon="write" className="btn_blue_bg" />
        <Label
          as="a"
          name="saveCity"
          content={isMobile ? "Share Comments" : "Share Comments"}
          basic
          pointing="left"
          className="theme_blue btn_blue"
        />
      </ButtonItem>
    </span>
  );
};

export default ShareCommentsButton;
